<template>
  <div class="select-store-page c:col-between-center">
    <div class="logo c:row-center">
      <img class="pic" src="@/assets/images/favicon.png" alt="" />
    </div>
    <div class="select">
      <div class="select-item">
        <div class="select-item-label">
          <span class="required">选择门店</span>
        </div>
        <CSelect
          title="请选择"
          large
          v-model="selectedIndex"
          :options="storeOptions"
        ></CSelect>
      </div>
    </div>
    <div class="button">
      <CButton primary large :disabled="disabled" @click="onConfirm"
        >确定</CButton
      >
    </div>
    <CBottomPad />
    <CConfirm ref="refCConfirm" />
  </div>
</template>
<script>
import CBottomPad from "@/components/common/CBottomPad.vue";
import CButton from "@/components/common/CButton.vue";
import CConfirm from "@/components/common/CConfirm.vue";
import CSelect from "@/components/common/CSelect.vue";
import { USER_ROLES } from "@/consts";
import normalPage from "@/mixins/normal-page";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  mixins: [normalPage],
  components: { CSelect, CButton, CConfirm, CBottomPad },
  data() {
    return {
      hasCurrentStore: false,
      currentIndex: undefined,
      selectedIndex: undefined,
    };
  },
  computed: {
    ...mapState(["account", "user"]),
    ...mapGetters(["canSwitchStore"]),
    storeOptions() {
      const { stores } = this.user;
      if (this.canSwitchStore && stores?.length) {
        return stores.map((store) => ({
          label: store.storeName,
          value: store.storeId,
        }));
      }
      return [];
    },
    disabled() {
      if (this.selectedIndex !== undefined) {
        return false;
      }
      return true;
    },
  },
  created() {
    if (!this.canSwitchStore) {
      this.gotoUserPage();
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions(["switchCurrentStore"]),
    init() {
      const {
        user: { stores, currentStore },
      } = this.$store.state;
      if (currentStore) {
        const index = stores.findIndex(
          (store) => store.storeId === currentStore.storeId
        );
        if (index > -1) {
          this.selectedIndex = this.currentIndex = index;
          this.hasCurrentStore = true;
        } else {
          this.selectedIndex = this.currentIndex = undefined;
          this.hasCurrentStore = false;
        }
      } else {
        this.selectedIndex = this.currentIndex = undefined;
        this.hasCurrentStore = false;
      }
    },
    async onConfirm() {
      try {
        if (this.hasCurrentStore && this.selectedIndex !== this.currentIndex) {
          await this.$refs.refCConfirm.show("确认切换店铺？");
          if (
            await this.switchCurrentStore(
              this.$store.state.user.stores[this.selectedIndex]
            )
          ) {
            this.gotoUserPage();
          }
        } else {
          this.gotoUserPage();
        }
      } catch (error) {
        console.log("error", error);
      }
    },
    gotoUserPage() {
      if (this.$route.query.from) {
        this.$router.replace(decodeURIComponent(this.$route.query.from));
      } else {
        if (this.account.role === USER_ROLES.CLIENT_AGENT) {
          this.$router.replace({ name: "SADashboard" });
        } else if (this.account.role === USER_ROLES.STORE_MANAGER) {
          this.$router.replace({ name: "StoreManagerDashboard" });
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
.select-store-page {
  width: 100%;
  height: 100%;
  background-color: #fff;

  .logo {
    width: 100%;
    padding: 20/20rem;

    .pic {
      width: 246/20rem;
      height: auto;
    }
  }

  .select {
    flex: 1;
    width: 100%;
    // height: 0;
    padding: 10/20rem 20/20rem;

    &-item {
      &-label {
        font-size: 22/40rem;
        margin-bottom: 12/40rem;
      }
    }
  }
  .button {
    width: 100%;
    padding: 8/20rem 20/20rem;
  }
}
</style>
